<template>
  <FormPanel :title="t('modules.commandMenu.v2.options')" class="global-search-options">
    <SearchTypeSection
      :types="visiblePrimaryTypes"
      :selected-types="selectedTypes"
      :counts="counts"
      @toggle="toggle"
    />
    <div v-if="visibleAdditionalTypes.length" class="font-bold mt-3 mb-2">
      {{ t("modules.commandMenu.v2.moreContent") }}
    </div>
    <SearchTypeSection
      :types="visibleAdditionalTypes"
      :selected-types="selectedTypes"
      :counts="counts"
      @toggle="toggle"
    />
  </FormPanel>
</template>

<script setup lang="ts">
import { computed } from "vue";
import FormPanel from "@/components/shared/form/FormPanel.vue";
import { useAppTranslate } from "@/language/staticTranslations";
import SearchTypeSection from "./SearchTypeSection.vue";
import {
  additionalSearchTypes,
  primarySearchTypes,
  type GlobalSearchUIType,
} from "../helper/GlobalSearchTypes";

const props = defineProps<{
  availableTypes: GlobalSearchUIType[];
  counts?: Map<GlobalSearchUIType, number>;
}>();
const { t } = useAppTranslate();

const selectedTypes = defineModel<GlobalSearchUIType[]>({ required: true });
const visiblePrimaryTypes = computed(() =>
  primarySearchTypes.filter((type) => props.availableTypes.includes(type)),
);
const visibleAdditionalTypes = computed(() =>
  additionalSearchTypes.filter((type) => props.availableTypes.includes(type)),
);

function toggle(type: GlobalSearchUIType, selected: boolean) {
  selectedTypes.value = selected
    ? [...new Set([...selectedTypes.value, type])]
    : selectedTypes.value.filter((selectedType) => selectedType !== type);
}
</script>

<style scoped lang="scss">
.global-search-options {
  color: var(--p-text-color);
}
</style>
